

import { html, LitElement, } from 'lit-element';

export class IconHeaert extends LitElement {
  static get properties() {
    return {
      active: { type: Boolean, reflect: true, },
      width: { type: Number, reflect: true, },
      height: { type: Number, reflect: true, },
    };
  }

  constructor() {
    super();
    this.width = 30;
    this.height = 30;
  }
  
  render() {
    return html`
    ${this.active
    ? html`<svg width="${this.width}" height="${this.height}" fill="currentColor" version="1.1" id="레이어_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 132 132" style="enable-background:new 0 0 132 132;" xml:space="preserve"><style type="text/css">.st0{fill:red;}</style><g id="Heart" transform="translate(0.5 134.5)"><g id="Heart-2"><path class="st0" d="M65.5-20.3L20.8-65C9-76.8,9-96,20.8-107.8c11.8-11.8,31-11.8,42.8,0l1.9,1.9l1.9-1.9c5.9-5.9,13.4-8.9,21.4-8.9c0.1,0,0.1,0,0.2,0c8,0,15.6,3.2,21.2,8.9l-3.9,3.8c-4.6-4.7-10.8-7.3-17.4-7.3c-6.4-0.1-12.8,2.5-17.5,7.1l-6,6l-5.7-5.7c-9.7-9.7-25.4-9.7-35.1,0s-9.7,25.4,0,35.1L65.5-28l40.8-40.8c9.7-9.6,9.8-25.2,0.2-34.8l1.7-2.2l2-1.9c11.9,12,11.8,31.1,0,42.8L65.5-20.3z"/></g></g></svg>`
    : html`<svg width="${this.width}" height="${this.height}" fill="currentColor" version="1.1" id="레이어_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 132 132" style="enable-background:new 0 0 132 132;" xml:space="preserve"><style type="text/css">.st0{fill:#4D4D4D;}</style><g id="Heart" transform="translate(0.5 134.5)"><g id="Heart-2"><path class="st0" d="M65.5-20.3L20.8-65C9-76.8,9-96,20.8-107.8c11.8-11.8,31-11.8,42.8,0l1.9,1.9l1.9-1.9c5.9-5.9,13.4-8.9,21.4-8.9c0.1,0,0.1,0,0.2,0c8,0,15.6,3.2,21.2,8.9l-3.9,3.8c-4.6-4.7-10.8-7.3-17.4-7.3c-6.4-0.1-12.8,2.5-17.5,7.1l-6,6l-5.7-5.7c-9.7-9.7-25.4-9.7-35.1,0s-9.7,25.4,0,35.1L65.5-28l40.8-40.8c9.7-9.6,9.8-25.2,0.2-34.8l1.7-2.2l2-1.9c11.9,12,11.8,31.1,0,42.8L65.5-20.3z"/></g></g></svg>`}    
    `;
  }
}

customElements.define('icon-heart', IconHeaert);